import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
// import CommonAlert from "../../Commonalert/commonalert";
import { Breadcrumbs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { timezonechange } from "../Commonfun";
// import { timezoneval } from "./Commonfun";
import { ToastContainer, toast } from 'react-toastify';
import { Helmet } from "react-helmet";
import Loader from "../CommonLoader";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import { AppContext } from "../../../Context/Context";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";



export default function Ticketdetail() {

    const param = useParams();
    const navigate = useNavigate();
    const ticketId = param.id;
    const esodata = useSelector((state) => state);
    const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
    const apiToken = esodata?.apiauthkey?.value;
    const [ticketDetail, setticketDetail] = useState(null);
    const [ticketStatus, setTicketStatus] = useState(true);
    const [apiopen, setapiOpen] = useState(false);
    const [apierrorMsg, setapierrorMsg] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchTicketDetails();
    }, []);

    const fetchTicketDetails = () => {
        setLoading(true);
        console.log('apiToken', apiToken);
        axios.get(`${process.env.REACT_APP_API_URL}support_tickets/get_detail_ticket/?ticket_id=${ticketId}`, {
            headers: {
                Authorization: `${apiToken}`,
            }
        }).then(ticketDetail => {
            console.log('ticketDetail', ticketDetail)
            setticketDetail(ticketDetail.data)
            setTicketStatus(ticketDetail.data?.is_open);
        }).catch(error => {
            if (
                error?.response?.status == 599 ||
                error?.response?.status == 400 ||
                error?.response?.status == 500
            ) {
                setapiOpen(true);
                setapierrorMsg(error?.response?.data?.error);
            } else if (
                error?.code == "ERR_NETWORK" ||
                error?.response?.status == 404
            ) {
                navigate("/errorpages");
            }
        })
        setLoading(false);
    }

    const apihandleClose = () => {
        setapiOpen(false);
    };

    const updateTicketStatus = async (selectedStatus,) => {
        console.log('selectedStatus', selectedStatus.target.value);
        setLoading(true);
        try {
            const datavalue = await axios
                .post(
                    `${process.env.REACT_APP_API_URL}business_admin/update_ticket/`,
                    {
                        "ticket_id": ticketDetail?.id,
                        "status": selectedStatus.target.value
                    },
                    {
                        headers: {
                            Authorization: `${apiToken}`,
                        },
                    },
                )
                .catch((error) => {
                    if (
                        error?.response?.status == 599 ||
                        error?.response?.status == 400 ||
                        error?.response?.status == 500
                    ) {
                        setapiOpen(true);
                        setapierrorMsg(error?.response?.data?.error);
                    } else if (
                        error?.code == "ERR_NETWORK" ||
                        error?.response?.status == 404
                    ) {
                        navigate("/errorpages");
                    }
                });
            if (datavalue) {
                toast.success("Updated Successfully", {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            }
        } catch (err) {
            if (err.code == "ERR_NETWORK") {
                navigate("/*");
            }
        }
        setLoading(false);
    }

    const handleDownload = async (attachment) => {
        console.log('ff')
        const link = document.createElement("a");
        link.href = attachment.url;
        link.setAttribute("download", attachment.file_name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleImageClick = (url) => {
        window.open(url, "_blank");
    };

    return (
        <><ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
        />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Ticket Detail</title>
            </Helmet>
            {loading === true ? <Loader /> : null}
            <div className={`over_all_container over_all_accessibility ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
                <Container maxWidth={false} className="dashboard-container">
                    <Box className="dashboard-box">
                        <Grid container className="dashboard-grid">
                            <Grid item xs={12} md={4}>
                                <div>
                                    <h1 className="dashboard_header">
                                        Ticket Details
                                    </h1>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <div className="top_breadcrumb_menu">
                                    <div className="exportpdf_outer">
                                        <div className="breadcrumb-wrapper">
                                            <CommonBreadCrumb breadcrumbValue={[
                                                { title: 'Support Ticket', active: true, link: ticketStatus ? '/support-open-ticket-list' : '/support-closed-ticket-list' },
                                                { title: 'Ticket Details', active: true }
                                            ]} />
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="dashboard-card-container">
                    <Box className="dashboard-box-card">
                        <Grid container className="dashboard-card-grid">
                            <Grid item xs={12} md={12}>
                                <div className="">
                                    <div className="color-checker-container">
                                        <table className="table">
                                            <col style={{ width: "50%" }} />
                                            <col style={{ width: "50%" }} />
                                            <tbody>
                                                {/* <tr>
                                <td className="table-label">Username: </td>
                                <td>{ticketDetail?.user?.username}</td>
                            </tr>
                            <tr>
                                <td className="table-label">Email: </td>
                                <td>{ticketDetail?.user?.email}</td>
                            </tr> */}
                                                <tr>
                                                    <td className="table-label" style={{ fontWeight: 800 }}>Title: </td>
                                                    <td>{ticketDetail?.title}</td>
                                                </tr>
                                                <tr>
                                                    <td className="table-label" style={{ fontWeight: 800 }}>Description: </td>
                                                    <td>{ticketDetail?.description}</td>
                                                </tr>
                                                <tr>
                                                    <td className="table-label" style={{ fontWeight: 800 }}>Status: </td>
                                                    <td>
                                                        {ticketDetail?.status}

                                                    </td>
                                                </tr>
                                                {/* <tr>
                                <td className="table-label">Is Open: </td>
                                <td>{ticketDetail?.is_open ? 'Yes' : 'No'}</td>
                            </tr>
                            <tr>
                                <td className="table-label">Assigned to: </td>
                                <td>{ticketDetail?.assigned_to}</td>
                            </tr> */}
                                                {/* <tr>
                                <td className="table-label">URL: </td>
                                <td>
                                    <a target="_blank" href={ticketDetail.website_url} style={{ display: 'flex', flexDirection: 'column' }}>
                                        <span className="spanlink" style={{ flexDirection: "column" }}>
                                            {ticketDetail.website_url}
                                        </span>
                                    </a>
                                </td>
                            </tr> */}
                                                <tr>
                                                    <td className="table-label" style={{ fontWeight: 800 }}>Created On: </td>
                                                    <td>{timezonechange(ticketDetail?.created_at)}</td>
                                                </tr>
                                                {ticketDetail?.attachments?.length > 0 && (
                                                    <tr>
                                                        <td className="table-label" style={{ fontWeight: 800 }}>Attachments:</td>
                                                        <td>
                                                            {ticketDetail.attachments.map((attachment, index) => {
                                                                return attachment.view_type === "download" ? (
                                                                    <button key={index} onClick={() => handleDownload(attachment)}>
                                                                        {attachment.file_name}
                                                                    </button>
                                                                ) : (
                                                                    <img
                                                                        key={index}
                                                                        src={attachment.url}
                                                                        alt={attachment.file_name}
                                                                        style={{ maxWidth: "150px", maxHeight: "150px" }}
                                                                        onClick={() => handleImageClick(attachment.url)}
                                                                    />
                                                                );
                                                            })}
                                                        </td>
                                                    </tr>
                                                )}

                                                {/* <tr>
                                <td className="table-label">Message: </td>
                                <td>{ticketDetail.message}</td>
                            </tr>
                            <tr>
                                <td className="table-label">Reason: </td>
                                <td>{ticketDetail.reason}</td>
                            </tr> */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>

                <Container maxWidth={false} className="footer-container">
                    <Box className="footer-box">
                        <Grid container className="footer-grid">
                            <Grid item xs={12} md={6}>
                                <div className="footer-left">
                                    <p className="footer-text">
                                        All Rights Reserved Copyright © 2025 |
                                        <a href="https://www.egrovesys.com/" target="blank">
                                            <span className="footer-brand">eGrove Systems</span>
                                        </a>
                                    </p>
                                </div>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <div className="footer-right">
                                    <p>{/* Add content if needed */}</p>
                                </div>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>


                {/* <div className="top_breadcrumb_menu">
                    <CommonBreadCrumb breadcrumbValue={[
                        { title: 'Support Tickets', active: true, link: '/support-open-ticket-list' },
                        { title: 'Ticket Details', active: true }
                    ]} />
                </div>
                <div className="cnt_hdr_top_wraps">
                    <div className="cnt_hdr_top_lft_wrap">
                        <div >
                            <h2 className="heading_font" style={{ margin: 'auto' }}>Ticket Details</h2>
                        </div>
                    </div>
                </div>
                <div className="color-checker-container">
                    <table className="table">
                        <col style={{ width: "50%" }} />
                        <col style={{ width: "50%" }} />
                        <tbody>
                            <tr>
                                <td className="table-label" style={{ fontWeight: 800 }}>Title: </td>
                                <td>{ticketDetail?.title}</td>
                            </tr>
                            <tr>
                                <td className="table-label" style={{ fontWeight: 800 }}>Description: </td>
                                <td>{ticketDetail?.description}</td>
                            </tr>
                            <tr>
                                <td className="table-label" style={{ fontWeight: 800 }}>Status: </td>
                                <td>
                                    {ticketDetail?.status}

                                </td>
                            </tr>
                            <tr>
                                <td className="table-label" style={{ fontWeight: 800 }}>Created On: </td>
                                <td>{timezonechange(ticketDetail?.created_at)}</td>
                            </tr>
                            {ticketDetail?.attachments?.length > 0 && (
                                <tr>
                                    <td className="table-label" style={{ fontWeight: 800 }}>Attachments:</td>
                                    <td>
                                        {ticketDetail.attachments.map((attachment, index) => {
                                            return attachment.view_type === "download" ? (
                                                <button key={index} onClick={() => handleDownload(attachment)}>
                                                    {attachment.file_name}
                                                </button>
                                            ) : (
                                                <img
                                                    key={index}
                                                    src={attachment.url}
                                                    alt={attachment.file_name}
                                                    style={{ maxWidth: "150px", maxHeight: "150px" }}
                                                />
                                            );
                                        })}
                                    </td>
                                </tr>
                            )}

                        </tbody>
                    </table>
                </div> */}

                <CommonErrorAlert
                    data={{
                        apiopen: apiopen,
                        apiErrorMsg: apierrorMsg,
                        isIconStyled: true
                    }}
                    closeAlert={apihandleClose}
                />
            </div>
        </>
    )
}